module.exports = __webpack_public_path__ + "img/formula-1.de17b2f6.png";